"use client";
import { ExternalButton } from "@sharedComponents/buttons";

import { useStoreContext } from "@components/store/provider";

import { isValidUrl } from "@stadium/helpers/src/links";

import useLockerUrlConfig from "@hooks/use-locker-url-config";

import { DEFAULT_COUNTRY_ISO } from "@stadium/constants";
import { DEFAULT_LANG_SLUG } from "@constants/app-defaults";
import { getBrandRoute } from "@constants/routes";

import styles from "./main.module.scss";

const ShowAllBrandProductsCta = ({ brandSlug, buttonText, buttonLink }) => {
  const { lockerFeUrl } = useLockerUrlConfig();

  const { storeBasePath, isPreviewCatalogMode } = useStoreContext();

  const usLockerFeURL = (() => {
    if (!isValidUrl(lockerFeUrl)) return "";
    const url = new URL(lockerFeUrl);
    const pathPrefix = `${DEFAULT_COUNTRY_ISO.toLowerCase()}-${DEFAULT_LANG_SLUG}`;
    url.pathname = `${pathPrefix}${url.pathname}`;
    return url.toString();
  })();

  return (
    <ExternalButton
      styleType="primary"
      className={styles.productFooterButton}
      href={
        buttonLink ||
        getBrandRoute({
          storeBasePath: isPreviewCatalogMode ? usLockerFeURL : storeBasePath,
          brandSlug,
        })
      }
      target={isPreviewCatalogMode ? "_blank" : ""}
      showExternalLinkIcon={isPreviewCatalogMode ? "_blank" : ""}
      title={buttonText || "Browse the Collection"}
    >
      {buttonText || "Browse the Collection"}
    </ExternalButton>
  );
};

export default ShowAllBrandProductsCta;
